<div class="container-fluid glb-popup" style="max-width: 800px ;">
  <h2 class="kbm-section-headline"> {{formTitle}}</h2>

  <!-- KBM 2026: Property summary callout with Maps link + linked owner indicator -->
  @if (propertyLeadProfileId) {
    <div class="kbm-prop-summary">
      <div class="kbm-prop-summary-info">
        <span class="kbm-meta-label">Subject Property</span>
        <span class="kbm-meta-value">
          {{ propertyLeadProfile?.subjAdrDevelopmentName || propertyLeadProfile?.subjAdrStreet || 'Unnamed property' }}
          <span *ngIf="propertyLeadProfile?.subjAdrUnit"> · Unit {{ propertyLeadProfile?.subjAdrUnit }}</span>
        </span>
        <span class="kbm-meta-sub" *ngIf="propertyLeadProfile?.subjAdrCity">
          {{ propertyLeadProfile?.subjAdrCity }}<span *ngIf="propertyLeadProfile?.subjAdrState">, {{ propertyLeadProfile?.subjAdrState }}</span>
        </span>
      </div>
      <div class="kbm-prop-summary-actions">
        <a *ngIf="googleMapsUrl" [href]="googleMapsUrl" target="_blank" rel="noopener" class="kbm-btn kbm-btn-outline">
          <i class="pi pi-map-marker"></i> Open in Maps
        </a>
        <span class="kbm-prop-owner-pill" *ngIf="propertyLeadProfile?.ownerLeadProfileVOList?.length > 0 || propertyLeadProfile?.ownerLeadProfiles?.length > 0">
          <i class="pi pi-user"></i>
          {{ (propertyLeadProfile?.ownerLeadProfileVOList?.length || propertyLeadProfile?.ownerLeadProfiles?.length) }}
          linked owner lead{{ ((propertyLeadProfile?.ownerLeadProfileVOList?.length || propertyLeadProfile?.ownerLeadProfiles?.length) === 1 ? '' : 's') }}
        </span>
      </div>
    </div>
  }
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button (click)="closePopUpOfQuote()" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        <!-- TAX RECORD OWNER DETAILS FIELDS -->

        @if (isDisplayOwnerProfile) {
          <div class="row d-flex justify-content-between">
            <div class="col-12 row py-0">
              <div class="col-lg-6">
                <span class="p-float-label required-field w-100 mb-4">
                  <p-multiSelect class="lead-select" [options]="ownerLeadProfilesList" formControlName="ownerLeadProfiles"
                    appendTo="body" defaultLabel="Select Owner Lead Profiles" optionLabel="customName"
                  display="chip"></p-multiSelect>
                  <label for="Select Owner Lead Profiles">Select Owner Lead Profiles</label>
                  @for (validation of validationMessages.ownerLeadProfiles; track validation) {
                    <span>
                      @if (form1.get('ownerLeadProfiles').hasError(validation.type) && (form1.get('ownerLeadProfiles').dirty || form1.get('ownerLeadProfiles').touched)) {
                        <small class="p-invalid"
                          >{{validation.message}}
                        </small>
                      }
                    </span>
                  }
                </span>
              </div>
              <div class="col-1 py-0 d-flex justify-content-end align-items-center">
                <button class="btn btn-icon btn-success rounded-pill mb-4" (click)="formAddPropertyLead()">
                  <i class="pi pi-plus"></i>
                </button>
              </div>
            </div>
          </div>
        }






        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <p-dropdown [options]="listingStatuses" formControlName="listingStatus" optionLabel="name"
              optionValue="value" [filter]="true" filterBy="value" [showClear]="false"
            placeholder="Select Status"></p-dropdown>
            <label for="Select Status">Select Status</label>
            @for (validation of validationMessages.listingStatus; track validation) {
              <span>
                @if (form1.get('listingStatus').hasError(validation.type) && (form1.get('listingStatus').dirty || form1.get('listingStatus').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6"></div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100">
            <p-dropdown [options]="targetPriorities" formControlName="targetPriorityNum" optionLabel="name"
              optionValue="value" [showClear]="false"
            placeholder="Select Target Priority"></p-dropdown>
            <label for="targetPriorityNum">Select Target Priority</label>
            @for (validation of validationMessages.targetPriorityNum; track validation) {
              <span>
                @if (form1.get('targetPriorityNum').hasError(validation.type) && (form1.get('targetPriorityNum').dirty || form1.get('targetPriorityNum').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6"></div>


        <h6 class="pt-6" style="color:darkorange">Subject Address</h6>

        <div class="col-lg-3">
          <span class="p-float-label w-100 mb-3">
            <p-calendar formControlName="subjSaleDate" inputId="subjSaleDate" appendTo="body">
            </p-calendar>
            <label for="subjSaleDate">Subj Sale Date</label>
            @for (validation of validationMessages.subjSaleDate; track validation) {
              <span>
                @if (form1.get('subjSaleDate').hasError(validation.type) && (form1.get('subjSaleDate').dirty || form1.get('subjSaleDate').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-3">
          <span class="p-float-label required-field w-100 mb-3">
            <p-inputNumber formControlName="subjSaleAmount" [minFractionDigits]="0" inputId="currency-us" mode="currency" currency="USD" locale="en-US">
            </p-inputNumber>
            <label for="subjSaleAmount">Subj Sale Amount</label>
            @for (validation of validationMessages.subjSaleAmount; track validation) {
              <span>
                @if (form1.get('subjSaleAmount').hasError(validation.type) && (form1.get('subjSaleAmount').dirty || form1.get('subjSaleAmount').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-3">
          <span class="p-float-label required-field w-100 mb-3">
            <p-inputNumber formControlName="subjAppreciation" [minFractionDigits]="0" inputId="currency-us" mode="currency" currency="USD" locale="en-US">
            </p-inputNumber>
            <label for="subjAppreciation">Subj Appreciation</label>
            @for (validation of validationMessages.subjAppreciation; track validation) {
              <span>
                @if (form1.get('subjAppreciation').hasError(validation.type) && (form1.get('subjAppreciation').dirty || form1.get('subjAppreciation').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-3">
          <span class="p-float-label required-field w-100 mb-3">
            <p-inputNumber formControlName="subjValue" [minFractionDigits]="0" inputId="currency-us" mode="currency" currency="USD" locale="en-US">
            </p-inputNumber>
            <label for="subjValue">Subj Value</label>
            @for (validation of validationMessages.subjValue; track validation) {
              <span>
                @if (form1.get('subjValue').hasError(validation.type) && (form1.get('subjValue').dirty || form1.get('subjValue').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="subjLegalDesc" id="subjLegalDesc" [rows]="1" pInputTextarea></textarea>
            <label for="subjLegalDesc">Subj Legal Desc</label>
            @for (validation of validationMessages.subjLegalDesc; track validation) {
              <span>
                @if (form1.get('subjLegalDesc').hasError(validation.type) && (form1.get('subjLegalDesc').dirty || form1.get('subjLegalDesc').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="subjLocationDesc" id="subjLocationDesc" [rows]="1" pInputTextarea></textarea>
            <label for="subjLocationDesc">Subj Location Desc</label>
            @for (validation of validationMessages.subjLocationDesc; track validation) {
              <span>
                @if (form1.get('subjLocationDesc').hasError(validation.type) && (form1.get('subjLocationDesc').dirty || form1.get('subjLocationDesc').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>


        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="subjAdrDevelopmentName" id="subjAdrDevelopmentName" type="text" pInputText>
            <label for="subjAdrDevelopmentName">Development</label>
            @for (validation of validationMessages.subjAdrDevelopmentName; track validation) {
              <span>
                @if (form1.get('subjAdrDevelopmentName').hasError(validation.type) && (form1.get('subjAdrDevelopmentName').dirty || form1.get('subjAdrDevelopmentName').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-8">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="subjAdrStreet" id="subjAdrStreet" type="text" pInputText>
            <label for="subjAdrStreet">Street</label>
            @for (validation of validationMessages.subjAdrStreet; track validation) {
              <span>
                @if (form1.get('subjAdrStreet').hasError(validation.type) && (form1.get('subjAdrStreet').dirty || form1.get('subjAdrStreet').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>


        <div class="col-lg-4">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="subjAdrUnit" id="subjAdrUnit" type="text" pInputText>
            <label for="subjAdrUnit">Unit #</label>
            @for (validation of validationMessages.subjAdrUnit; track validation) {
              <span>
                @if (form1.get('subjAdrUnit').hasError(validation.type) && (form1.get('subjAdrUnit').dirty || form1.get('subjAdrUnit').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="subjAdrStreet2" id="subjAdrStreet2" type="text" pInputText>
            <label for="subjAdrStreet2">Street2</label>
            @for (validation of validationMessages.subjAdrStreet2; track validation) {
              <span>
                @if (form1.get('subjAdrStreet2').hasError(validation.type) && (form1.get('subjAdrStreet2').dirty || form1.get('subjAdrStreet2').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-2">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="subjAdrCity" id="subjAdrCity" type="text" pInputText>
            <label for="subjAdrCity">City</label>
            @for (validation of validationMessages.subjAdrCity; track validation) {
              <span>
                @if (form1.get('subjAdrCity').hasError(validation.type) && (form1.get('subjAdrCity').dirty || form1.get('subjAdrCity').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-2">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown [options]="states" formControlName="subjAdrState" optionLabel="name" appendTo="body"
              optionValue="abbr" [filter]="true" filterBy="name" [showClear]="false" placeholder="State">
            </p-dropdown>
            <label for="State">State</label>
            @for (validation of validationMessages.subjAdrState; track validation) {
              <span>
                @if (form1.get('subjAdrState').hasError(validation.type) && (form1.get('subjAdrState').dirty || form1.get('subjAdrState').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-2">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="subjAdrPostalCode" id="subjAdrPostalCode" type="text" pInputText>
            <label for="subjAdrPostalCode">Postal Code</label>
            @for (validation of validationMessages.subjAdrPostalCode; track validation) {
              <span>
                @if (form1.get('subjAdrPostalCode').hasError(validation.type) && (form1.get('subjAdrPostalCode').dirty || form1.get('subjAdrPostalCode').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-2">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="subjAdrCountyId" id="subjAdrCountyId" type="text" pInputText>
            <label for="subjAdrCountyId">CountyId</label>
            @for (validation of validationMessages.subjAdrCountyId; track validation) {
              <span>
                @if (form1.get('subjAdrCountyId').hasError(validation.type) && (form1.get('subjAdrCountyId').dirty || form1.get('subjAdrCountyId').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-2">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown [options]="countries" formControlName="subjAdrCountry" optionLabel="name"
              appendTo="body" optionValue="abbr" [filter]="true" filterBy="name" [showClear]="false"
              placeholder="Country">
            </p-dropdown>
            <label for="Country">Country</label>
            @for (validation of validationMessages.subjAdrCountry; track validation) {
              <span>
                @if (form1.get('subjAdrCountry').hasError(validation.type) && (form1.get('subjAdrCountry').dirty || form1.get('subjAdrCountry').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-2">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="subAdrIsland" id="subAdrIsland" type="text" pInputText>
            <label for="subAdrIsland">Sub Adr Island</label>
            @for (validation of validationMessages.subAdrIsland; track validation) {
              <span>
                @if (form1.get('subAdrIsland').hasError(validation.type) && (form1.get('subAdrIsland').dirty || form1.get('subAdrIsland').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-3">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="subjAdrRegion" id="subjAdrRegion" type="text" pInputText>
            <label for="subjAdrRegion">Subj Adr Region</label>
            @for (validation of validationMessages.subjAdrRegion; track validation) {
              <span>
                @if (form1.get('subjAdrRegion').hasError(validation.type) && (form1.get('subjAdrRegion').dirty || form1.get('subjAdrRegion').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-3">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="subjAdrDistrict" id="subjAdrDistrict" type="text" pInputText>
            <label for="subjAdrDistrict">Subj Adr District</label>
            @for (validation of validationMessages.subjAdrDistrict; track validation) {
              <span>
                @if (form1.get('subjAdrDistrict').hasError(validation.type) && (form1.get('subjAdrDistrict').dirty || form1.get('subjAdrDistrict').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-3">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="subjAdrPhone" id="subjAdrPhone" type="text" pInputText maxlength="15" (input)="formatPhoneField('subjAdrPhone')">
            <label for="subjAdrPhone">Subj Adr Phone</label>
            @for (validation of validationMessages.subjAdrPhone; track validation) {
              <span>
                @if (form1.get('subjAdrPhone').hasError(validation.type) && (form1.get('subjAdrPhone').dirty || form1.get('subjAdrPhone').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-3">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="subjAdrFax" id="subjAdrFax" type="text" pInputText>
            <label for="subjAdrFax">Subj Adr Fax</label>
            @for (validation of validationMessages.subjAdrFax; track validation) {
              <span>
                @if (form1.get('subjAdrFax').hasError(validation.type) && (form1.get('subjAdrFax').dirty || form1.get('subjAdrFax').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>





        <h6 class="pt-4" style="color:darkorange">Property Details</h6>
        <div class="col-lg-4">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="propertyTypes" formControlName="propertyType" optionLabel="name"
            optionValue="value" placeholder="Select Property Type"></p-dropdown>
            <label for="Select Property Type">Select Property Type</label>
            @for (validation of validationMessages.propertyType; track validation) {
              <span>
                @if (form1.get('propertyType').hasError(validation.type) && (form1.get('propertyType').dirty || form1.get('propertyType').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>



        <!-- <div class="col-lg-3">
        <span class="p-float-label required-field w-100 mb-3">
          <p-inputNumber  formControlName="propertyValue" id="propertyValue" inputId="currency-us" mode="currency" currency="USD" locale="en-US">
          </p-inputNumber>
          <label for="propertyValue">Property Value</label>
          <span *ngFor="let validation of validationMessages.propertyValue">
            <small class="p-invalid"
              *ngIf="form1.get('propertyValue').hasError(validation.type) && (form1.get('propertyValue').dirty || form1.get('propertyValue').touched)">{{validation.message}}
            </small>
          </span>
        </span>
      </div> -->

      <div class="col-lg-2">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="parcelId" id="parcelId" type="text" pInputText>
          <label for="parcelId">Parcel Id</label>
          @for (validation of validationMessages.parcelId; track validation) {
            <span>
              @if (form1.get('parcelId').hasError(validation.type) && (form1.get('parcelId').dirty || form1.get('parcelId').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>


      <div class="col-lg-2">
        <span class="p-float-label w-100 mb-3">
          <input formControlName="vendorSrcId" id="vendorSrcId" type="text" pInputText>
          <label for="vendorSrcId">Vendor Src Id</label>
          @for (validation of validationMessages.vendorSrcId; track validation) {
            <span>
              @if (form1.get('vendorSrcId').hasError(validation.type) && (form1.get('vendorSrcId').dirty || form1.get('vendorSrcId').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
      <div class="col-lg-4">
        <span class="p-float-label w-100 mb-3">
          <input formControlName="vendorSrcName" id="vendorSrcName" type="text" pInputText>
          <label for="vendorSrcName">Vendor Src Name</label>
          @for (validation of validationMessages.vendorSrcName; track validation) {
            <span>
              @if (form1.get('vendorSrcName').hasError(validation.type) && (form1.get('vendorSrcName').dirty || form1.get('vendorSrcName').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>


      <div class="col-lg-2">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="bedroomNum" id="bedroomNum" type="number" pInputText>
          <label for="bedroomNum"># Bedrooms</label>
          @for (validation of validationMessages.bedroomNum; track validation) {
            <span>
              @if (form1.get('bedroomNum').hasError(validation.type) && (form1.get('bedroomNum').dirty || form1.get('bedroomNum').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-2">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="bathroomNum" id="bathroomNum" type="number" pInputText>
          <label for="bathroomNum"># Bathrooms</label>
          @for (validation of validationMessages.bathroomNum; track validation) {
            <span>
              @if (form1.get('bathroomNum').hasError(validation.type) && (form1.get('bathroomNum').dirty || form1.get('bathroomNum').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-2">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="sizeInterior" id="sizeInterior" type="number" pInputText>
          <label for="sizeInterior">Interior Sq Ft</label>
          @for (validation of validationMessages.sizeInterior; track validation) {
            <span>
              @if (form1.get('sizeInterior').hasError(validation.type) && (form1.get('sizeInterior').dirty || form1.get('sizeInterior').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-2">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="floorOfProperty" id="floorOfProperty" type="number" pInputText>
          <label for="floorOfProperty">Floor of Building</label>
          @for (validation of validationMessages.floorOfProperty; track validation) {
            <span>
              @if (form1.get('floorOfProperty').hasError(validation.type) && (form1.get('floorOfProperty').dirty || form1.get('floorOfProperty').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-2">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="floorsInBuilding" id="floorsInBuilding" type="number" pInputText>
          <label for="floorsInBuilding">Floors In Building</label>
          @for (validation of validationMessages.floorsInBuilding; track validation) {
            <span>
              @if (form1.get('floorsInBuilding').hasError(validation.type) && (form1.get('floorsInBuilding').dirty || form1.get('floorsInBuilding').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-2">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="yearBuilt" id="yearBuilt" type="number" pInputText>
          <label for="yearBuilt">Year Built</label>
          @for (validation of validationMessages.yearBuilt; track validation) {
            <span>
              @if (form1.get('yearBuilt').hasError(validation.type) && (form1.get('yearBuilt').dirty || form1.get('yearBuilt').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>



      <!--	<div class="col-lg-3">
      <span class="p-float-label required-field w-100 mb-3">
        <input formControlName="sizeExterior" id="sizeExterior" type="number" pInputText>
        <label for="sizeExterior">Size Exterior</label>
        <span *ngFor="let validation of validationMessages.sizeExterior">
          <small class="p-invalid"
            *ngIf="form1.get('sizeExterior').hasError(validation.type) && (form1.get('sizeExterior').dirty || form1.get('sizeExterior').touched)">{{validation.message}}
          </small>
        </span>
      </span>
    </div>
    -->


    <div class="col-lg-4">
      <span class="p-float-label required-field w-100 mb-3">
        <input formControlName="vrboId" id="vrboId" type="text" pInputText>
        <label for="vrboId">Vrbo Id</label>
        @for (validation of validationMessages.vrboId; track validation) {
          <span>
            @if (form1.get('vrboId').hasError(validation.type) && (form1.get('vrboId').dirty || form1.get('vrboId').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>
    <div class="col-lg-4">
      <span class="p-float-label required-field w-100 mb-3">
        <input formControlName="airbnbId" id="airbnbId" type="text" pInputText>
        <label for="airbnbId">AirbnbId</label>
        @for (validation of validationMessages.airbnbId; track validation) {
          <span>
            @if (form1.get('airbnbId').hasError(validation.type) && (form1.get('airbnbId').dirty || form1.get('airbnbId').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>
    <div class="col-lg-4">
      <span class="p-float-label required-field w-100 mb-3">
        <input formControlName="ownerPointId" id="ownerPointId" type="text" pInputText>
        <label for="ownerPointId">OwnerPointId</label>
        @for (validation of validationMessages.ownerPointId; track validation) {
          <span>
            @if (form1.get('ownerPointId').hasError(validation.type) && (form1.get('ownerPointId').dirty || form1.get('ownerPointId').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>




    <h6 class="pt-6" style="color:darkorange">Current Owner</h6>
    <div class="col-lg-3">
      <span class="p-float-label w-100 mb-3">
        <p-dropdown class="w-100" [options]="ownersList" formControlName="ownershipType" optionLabel="name"
        optionValue="value" placeholder="Select Ownership Type"></p-dropdown>
        <label for="Select Ownership Type">Select Ownership Type</label>
        @for (validation of validationMessages.propertyType; track validation) {
          <span>
            @if (form1.get('ownershipType').hasError(validation.type) && (form1.get('ownershipType').dirty || form1.get('ownershipType').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>
    <div class="col-lg-9"></div>

    <div class="col-lg-6">
      <span class="p-float-label w-100 mb-3">
        <input formControlName="fullName" id="fullName" type="text" pInputText>
        <label for="fullName">Full Name</label>
        @for (validation of validationMessages.fullName; track validation) {
          <span>
            @if (form1.get('fullName').hasError(validation.type) && (form1.get('fullName').dirty || form1.get('fullName').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>
    <div class="col-lg-6">
      <span class="p-float-label w-100 mb-3">
        <input formControlName="ownerAge" id="ownerAge" type="text" pInputText>
        <label for="ownerAge">Owner Age</label>
        @for (validation of validationMessages.ownerAge; track validation) {
          <span>
            @if (form1.get('ownerAge').hasError(validation.type) && (form1.get('ownerAge').dirty || form1.get('ownerAge').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>
    <div class="col-lg-2">
      <span class="p-float-label required-field w-100 mb-3">
        <!-- <input formControlName="title" id="title" type="text" pInputText> -->
        <p-dropdown [options]="titles" formControlName="title" optionLabel="name" optionValue="value"
        [filter]="true" filterBy="value" [showClear]="false" placeholder="Title"></p-dropdown>
        <label for="title">Title</label>
        @for (validation of validationMessages.title; track validation) {
          <span>
            @if (form1.get('title').hasError(validation.type) && (form1.get('title').dirty || form1.get('title').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>

    <div class="col-lg-3">
      <span class="p-float-label required-field w-100 mb-3">
        <input formControlName="firstName" id="firstName" type="text" pInputText>
        <label for="firstName">First Name</label>
        @for (validation of validationMessages.firstName; track validation) {
          <span>
            @if (form1.get('firstName').hasError(validation.type) && (form1.get('firstName').dirty || form1.get('firstName').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>

    <div class="col-lg-3">
      <span class="p-float-label required-field w-100 mb-3">
        <input formControlName="lastName" id="lastName" type="text" pInputText>
        <label for="lastName">Last Name</label>
        @for (validation of validationMessages.lastName; track validation) {
          <span>
            @if (form1.get('lastName').hasError(validation.type) && (form1.get('lastName').dirty || form1.get('lastName').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>

    <div class="col-lg-4">
      <span class="p-float-label required-field w-100 mb-3">
        <input formControlName="suffix" id="suffix" type="text" pInputText>
        <label for="suffix">Suffix</label>
        @for (validation of validationMessages.suffix; track validation) {
          <span>
            @if (form1.get('suffix').hasError(validation.type) && (form1.get('suffix').dirty || form1.get('suffix').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>

    <div class="col-lg-6">
      <span class="p-float-label w-100 mb-3">
        <input formControlName="mailAdrCompanyName" id="mailAdrCompanyName" type="text" pInputText>
        <label for="mailAdrCompanyName">Company Name</label>
        @for (validation of validationMessages.mailAdrCompanyName; track validation) {
          <span>
            @if (form1.get('mailAdrCompanyName').hasError(validation.type) && (form1.get('mailAdrCompanyName').dirty || form1.get('mailAdrCompanyName').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>

    <div class="col-lg-6">
      <span class="p-float-label required-field w-100 mb-3">
        <input formControlName="careOf" id="careOf" type="text" pInputText>
        <label for="careOf">Care Of</label>
        @for (validation of validationMessages.careOf; track validation) {
          <span>
            @if (form1.get('careOf').hasError(validation.type) && (form1.get('careOf').dirty || form1.get('careOf').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>


    <div class="col-lg-6">
      <span class="p-float-label required-field w-100 mb-3">
        <input formControlName="emailAddress" id="emailAddress" type="email" pInputText>
        <label for="emailAddress">Email Address</label>
        @for (validation of validationMessages.emailAddress; track validation) {
          <span>
            @if (form1.get('emailAddress').hasError(validation.type) && (form1.get('emailAddress').dirty || form1.get('emailAddress').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>
    <div class="col-lg-6">
      <span class="p-float-label required-field w-100 mb-3">
        <input formControlName="emailAddress2" id="emailAddress2" type="email" pInputText>
        <label for="emailAddress2">Email Address2</label>
        @for (validation of validationMessages.emailAddress2; track validation) {
          <span>
            @if (form1.get('emailAddress2').hasError(validation.type) && (form1.get('emailAddress2').dirty || form1.get('emailAddress2').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>

    <div class="col-lg-3">
      <span class="p-float-label w-100 mb-3">
        <input formControlName="mailAdrPhone" id="mailAdrPhone" type="text" pInputText maxlength="15" (input)="formatPhoneField('mailAdrPhone')">
        <label for="mailAdrPhone">Published Phone</label>
        @for (validation of validationMessages.mailAdrPhone; track validation) {
          <span>
            @if (form1.get('mailAdrPhone').hasError(validation.type) && (form1.get('mailAdrPhone').dirty || form1.get('mailAdrPhone').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>



    <div class="col-lg-3">
      <span class="p-float-label required-field w-100 mb-3">
        <input formControlName="mobilePhone" id="mobilePhone" type="text" pInputText maxlength="15" (input)="formatPhoneField('mobilePhone')">
        <label for="mobilePhone">Mobile Phone</label>
        @for (validation of validationMessages.mobilePhone; track validation) {
          <span>
            @if (form1.get('mobilePhone').hasError(validation.type) && (form1.get('mobilePhone').dirty || form1.get('mobilePhone').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>

    <div class="col-lg-3">
      <span class="p-float-label w-100 mb-3">
        <input formControlName="phone2" id="phone2" type="text" pInputText maxlength="15" (input)="formatPhoneField('phone2')">
        <label for="phone2">Other Phone</label>
        @for (validation of validationMessages.phone2; track validation) {
          <span>
            @if (form1.get('phone2').hasError(validation.type) && (form1.get('phone2').dirty || form1.get('phone2').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>

    <div class="col-lg-3">
      <span class="p-float-label w-100 mb-3">
        <input formControlName="mailAdrFax" id="mailAdrFax" type="text" pInputText>
        <label for="mailAdrFax">Fax</label>
        @for (validation of validationMessages.mailAdrFax; track validation) {
          <span>
            @if (form1.get('mailAdrFax').hasError(validation.type) && (form1.get('mailAdrFax').dirty || form1.get('mailAdrFax').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>
    <div class="col-lg-12">
      <span class="p-float-label w-100 mb-3">
        <input formControlName="mailAdrStreet" id="mailAdrStreet" type="text" pInputText>
        <label for="mailAdrStreet">Street</label>
        @for (validation of validationMessages.mailAdrStreet; track validation) {
          <span>
            @if (form1.get('mailAdrStreet').hasError(validation.type) && (form1.get('mailAdrStreet').dirty || form1.get('mailAdrStreet').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>


    <div class="col-lg-12">
      <span class="p-float-label w-100 mb-3">
        <input formControlName="mailAdrStreet2" id="mailAdrStreet2" type="text" pInputText>
        <label for="mailAdrStreet2">Street2</label>
        @for (validation of validationMessages.mailAdrStreet2; track validation) {
          <span>
            @if (form1.get('mailAdrStreet2').hasError(validation.type) && (form1.get('mailAdrStreet2').dirty || form1.get('mailAdrStreet2').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>

    <div class="col-lg-5">
      <span class="p-float-label w-100 mb-3">
        <input formControlName="mailAdrCity" id="mailAdrCity" type="text" pInputText>
        <label for="mailAdrCity">City</label>
        @for (validation of validationMessages.mailAdrCity; track validation) {
          <span>
            @if (form1.get('mailAdrCity').hasError(validation.type) && (form1.get('mailAdrCity').dirty || form1.get('mailAdrCity').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>

    <div class="col-lg-2">
      <span class="p-float-label w-100 mb-3">
        <p-dropdown [options]="states" formControlName="mailAdrState" optionLabel="name" appendTo="body"
          optionValue="abbr" [filter]="true" filterBy="name" [showClear]="false" placeholder="State">
        </p-dropdown>
        <label for="State">State</label>
        @for (validation of validationMessages.mailAdrState; track validation) {
          <span>
            @if (form1.get('mailAdrState').hasError(validation.type) && (form1.get('mailAdrState').dirty || form1.get('mailAdrState').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>

    <div class="col-lg-2">
      <span class="p-float-label w-100 mb-3">
        <input formControlName="mailAdrPostalCode" id="mailAdrPostalCode" type="text" pInputText>
        <label for="mailAdrPostalCode">Postal Code</label>
        @for (validation of validationMessages.mailAdrPostalCode; track validation) {
          <span>
            @if (form1.get('mailAdrPostalCode').hasError(validation.type) && (form1.get('mailAdrPostalCode').dirty || form1.get('mailAdrPostalCode').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>

    <div class="col-lg-3">
      <span class="p-float-label w-100 mb-3">
        <p-dropdown [options]="countries" formControlName="mailAdrCountry" optionLabel="name"
          appendTo="body" optionValue="abbr" [filter]="true" filterBy="name" [showClear]="false"
          placeholder="Country">
        </p-dropdown>
        <label for="Country">Country</label>
        @for (validation of validationMessages.mailAdrCountry; track validation) {
          <span>
            @if (form1.get('mailAdrCountry').hasError(validation.type) && (form1.get('mailAdrCountry').dirty || form1.get('mailAdrCountry').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>
    <div class="col-lg-12">
      <span class="p-float-label w-100 mb-3">
        <textarea formControlName="opsNotes" id="opsNotes" [rows]="2" pInputTextarea></textarea>
        <label for="opsNotes">Ops Notes</label>
        @for (validation of validationMessages.opsNotes; track validation) {
          <span>
            @if (form1.get('opsNotes').hasError(validation.type) && (form1.get('opsNotes').dirty || form1.get('opsNotes').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>

    @if (propertyLeadProfileId) {
      <hr>
      }
      @if (propertyLeadProfileId) {
        <div class="col-lg-6">
          <app-tag-join-select
            [tagSource]="20" [tagSourceId]="propertyLeadProfileId" tagType="4" >
          </app-tag-join-select>
        </div>
      }

      @if (propertyLeadProfileId) {
        <hr>
        }
        @if (propertyLeadProfileId) {
          <div class="col-lg-12">
            <app-notes-chat [config]="notesChatConfig" [noteSourceId]="propertyLeadProfileId" [noteSource]="20">
            </app-notes-chat>
          </div>
        }

        @if (propertyLeadProfileId) {
          <hr>
          }
          @if (propertyLeadProfileId) {
            <div class="col-lg-12">
              <app-public-task-list [status]="1" [popupMode]="false" [taskSource]="20" [showFilter]="true" [taskSourceId]="propertyLeadProfileId" [passedTaskName]="'Property Lead Profile: ' + (propertyLeadProfile?.subjAdrStreet || '')">
              </app-public-task-list>
            </div>
          }
        </div>
      </div>

      <hr>
        <div class="row m-0">
          <div class="col-lg-12">
            <div class="btn-group">
              <div class="button-group">
                @if (propertyLeadProfileId) {
                  <button pButton class="btn-delete p-button-outlined p-button-danger"
                  (click)="onFormDelete()">Delete</button>
                }
              </div>

              <div class="button-group">
                <button pButton class="btn-cancel p-button-text" (click)="closePopUpOfQuote()">Close</button>
                @if (!propertyLeadProfileId) {
                  <button pButton class="btn-addt p-button" (click)="formAdd()">Add</button>
                }
                <button
                  pButton
                  type="button"
                  class="p-button p-button-success"
                  (click)="onCreateLeadConfirm()"
                  [disabled]="form1?.invalid">
                  <i class="pi pi-plus-circle p-button-icon p-button-icon-left"></i>
                  Create Lead
                </button>
                @if (propertyLeadProfileId) {
                  <button pButton class="btn-upt p-button" (click)="formUpdate()">Update</button>
                }

              </div>
            </div>
          </div>
        </div>
      </div>